// Imports Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef, MatDialog } from '@angular/material';

// Imports Aplicacion
import { DError, DContextoMuiscaServicio, DLogger, DContextoMuisca } from '@dian/core';
import { DRutServicios, DTipoContribuyente } from '@dian/api-rut';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DDocumento, DDocumentoAtributos, DFirmaElectronica, DListaDocumentos, DInfoResumenFormulario, DAniosFormato, DPeriodicidadFormato, DPeriodoFormato, DVersionRutaFormato } from '@dian/api-formulario';
import { DIVA300IngresoServicios, DRespuestaExencion } from '@dian-api/iva300-ingreso';
import { DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DOperacionesGeneralesServicio, DMensajes, DUtilidadesFormularioServicio, DOperacionesGeneralesIngresoServicio } from '@dian-cmp/formulario';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { DialogConfirmacionComponent } from './../dialog-confirmacion/dialog-confirmacion.component';
import { DialogoRespExencionesComponent } from './../dialogo-respuesta/dialogo-resp-exenciones.component';


@Component({
    moduleId: module.id,
    selector: 'ingreso',
    templateUrl: 'ingreso.component.html',
    styleUrls: ['ingreso.component.css'],
    providers: [
        DNotificacionServicio,
        DIVA300IngresoServicios,
        DRutServicios,
        DUtilidadesFormularioServicio,
        DReciboPagoDialogoServicio,
        DContextoUsuarioServicio
    ]
})
export class IngresoComponent implements OnInit {
    
    public mostrarOtros: boolean = false;
    public anioSeleccionadoPresentados:number;
    public arrDocumentosDiligenciamiento:DListaDocumentos;
    public arrDocumentosPresentados:DListaDocumentos;
    public arrDocumentosDefinitivos:DListaDocumentos;
    public constribuyenteId:string;
    public configuracionFormulario:DFormularioConfiguracion;
    public esFirmanteElectronico: DFirmaElectronica;
    public enProceso:boolean = true;
    public estadosCarga = {
        pendientes: false,
        presentados: false,
        definitivos: false,
        anios: false
    };
    public habilitarFraccionAnio:boolean = false; // CAMBIE A TRUE SI EL FORMULARIO REQUIERE EL USO DE FRACCIÓN DE AÑO
    public hayFraccion:boolean = false;
    public hayInicial:boolean = false;
    public fraccionAnio:boolean = false;
    public firmaRequerida:boolean = false;
    public operacionesGenerales:DOperacionesGeneralesIngresoServicio; 
    public mostrarNuevoBorrador:boolean = true;
    public mostrarNuevoBorradorFraccion:boolean = false;   
    public mostrarDocumentosEnProceso:boolean = true;
    public mostrarDocumentosEnBorrador:boolean = true;
    public mostrarDocumentosEnDefinitivo:boolean = true;
    public periodicidadDeshabilitada:boolean = true;    
    public aniosFormato:DAniosFormato;
    public aniosFraccion:Array<number>=[];
    public anioSeleccionado:number;
    public anioSeleccionadoFraccion:number;
    public periodicidadFormato:DPeriodicidadFormato;
    public periodicidadSelecionada:string;       
    public periodosFormato:DPeriodoFormato;
    public periodoSeleccionado = null;  
    public tipoContribuyente: DTipoContribuyente; 
    public periodicidadActual: DPeriodicidadFormato;
    public esInicialAnulacion: boolean = false;
    private datosContexto = new DContextoMuisca();
    private versionesRuta: Array<DVersionRutaFormato>;
    public disableBtnPagoCuotas:boolean = true;
    public existenDocsPresentadosAnio:boolean = false;
    public consultarRespuesta2020: boolean = false;
    public consultarRespuesta2021: boolean = false;
    public idPregunta: String;

    /**
     * @constructs ConfiguracionSelectorComponent
     */
    constructor(
        private router: Router,
        private dialog:MatDialog,
        private dNotificacionServicio: DNotificacionServicio,
        private dServicioRESTAPI: DIVA300IngresoServicios,
        private dRutServicios: DRutServicios,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private logger: DLogger,
        private dutilidades: DUtilidadesFormularioServicio,
        private dReciboPagoServicio: DReciboPagoDialogoServicio
    ) { 
        this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(this.dNotificacionServicio, this.dServicioRESTAPI, this.dialog); 
        this.configuracionFormulario = new DFormularioConfiguracion();
        this.arrDocumentosDiligenciamiento = new DListaDocumentos();  
        this.arrDocumentosPresentados = new DListaDocumentos();
        this.arrDocumentosDefinitivos = new DListaDocumentos();
        this.aniosFormato = new DAniosFormato();
        this.periodicidadFormato = new DPeriodicidadFormato();
        this.periodosFormato = new DPeriodoFormato();
        this.tipoContribuyente = new DTipoContribuyente();
        this.esFirmanteElectronico = new DFirmaElectronica();
        this.versionesRuta = new Array<DVersionRutaFormato>();
    }

    /**
    * Interface for on init document.
    * @interface
    */
    ngOnInit() { 
        setTimeout(() => {  
            this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta                     
        }, 50);        
        this.mostrarNuevoBorrador=true;
    }

     /**
    * @desc Funcion para conocer si el contribuyente tiene firma electronica
    * @param {String} ideDocumento
    */
    public consultarFirmanteElectronico(ideDocumento:string) {
        let observableServicio = this.operacionesGenerales.consultarFirmanteElectronico(ideDocumento);
        observableServicio.subscribe(
            res => {
                this.esFirmanteElectronico = <DFirmaElectronica>res;
                this.firmaRequerida = this.esFirmanteElectronico.esFirmaElectronica;
                
                if (this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO && !this.firmaRequerida) {                       
                    let dialogFirma = this.dNotificacionServicio.mostrarDialogoError(DMensajes.SIN_FIRMA_ELECTRONICA);
                    dialogFirma.afterClosed().subscribe(result => {
                        this.operacionesGenerales.irPaginaDashboard(); 
                    });                        
                } else {
                    this.enProceso = true;
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let definitivos = this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO;
                    this.obtenerDocs(definitivos ? false : true); 
                    this.obtenerIdentidad();  
                    this.obtenerAnios();  
                    this.validarCargaCompletaFormulario(precarga);  

                    this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);    
                }                    
            }
        );            
    } 

    /**
    * @desc Funcion para validar si el formulario esta completamente cargado y remover la animacion de precarga
    * @ignore
    */
    private validarCargaCompletaFormulario(precarga) {
        let intervalId = setInterval(()=>{
            let bandera = true;
            let atributos = Object.keys(this.estadosCarga);

            for(let i in atributos){
                if(!this.estadosCarga[atributos[i]]){
                    bandera = false;
                    break;
                }
            }

            if(bandera){
                this.enProceso = true;
                precarga.close();
                clearInterval(intervalId);  
            }                        
        }, 500);
    }

    /**
    * @desc Funcion para obtener los aÃ±os
    */
    private obtenerAnios() {
        let observableServicio = this.dServicioRESTAPI.consultarAniosFormato();
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Años ", res);
                this.aniosFormato = <DAniosFormato>res;
                let anios:Array<number>=[];
                this.aniosFormato.anios.forEach((anio) =>{
                    if(Number(anio)>2018){
                        anios.push(anio);
                    }else{
                        this.mostrarOtros = true;
                    }
                });
                this.aniosFormato.anios=anios;
                if (this.aniosFormato.anios.length === 1) {
                    this.anioSeleccionado = this.aniosFormato.anios[0];
                    this.obtenerPeriodicidad(this.anioSeleccionado);
                }                
                this.estadosCarga.anios = true;             
            },
            error => {
                this.estadosCarga.anios = true;
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de aÃ±os.");
            }
        );
    }

    public redireccionarSelectorFlex() {
        window.location.href = `${window.location.origin}/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=${this.configuracionFormulario.NUMERO_FORMULARIO}`
    }    

    /**
    * @desc Funcion para construir el listado de los años para fraccion de año
    */
    private obtenerAniosFraccion() {
        let anioActual = (new Date()).getFullYear();
        this.aniosFraccion.push(anioActual);
    }
    
    /**
    * @desc Funcion para verificar si el formulario debe de mostrar la seccion de fraccion de año
    * @param {Number} anio
    */
    private verificarFraccionAnio(anio:number) {
        let anioActual = (new Date()).getFullYear();
        this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;        
    }

    /**
    * @desc Funcion para obtener la periodicidad
    */
    private obtenerPeriodicidad(anio:number) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodicidad(anio);
        observableServicio.subscribe(
            res => {                
                this.logger.info("Obteniendo Periodicidad ", res);
                this.periodicidadFormato = <DPeriodicidadFormato>res;
                if (this.periodicidadFormato.listaPeriodicidades.length === 1) {
                    this.periodicidadSelecionada = this.periodicidadFormato.listaPeriodicidades[0].nombre;
                    this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);                    
                }

                /*
                if(this.arrDocumentosDiligenciamiento.infoFormularios.length > 0 || this.arrDocumentosPresentados.infoFormularios.length > 0 || this.arrDocumentosDefinitivos.infoFormularios.length > 0 ){
                    this.obtenerPeriodoActual(this.anioSeleccionado);    
                }
                */
                
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodicidades.");
            }
        );
    }

    /**
    * @desc Funcion para obtener los periodos
    */
    private obtenerPeriodos(anio:number, periodicidad:string) {        
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.consultarListaPeriodos(anio, periodicidad);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo Periodos ", res);
                this.periodosFormato = <DPeriodoFormato>res;
                if (this.periodosFormato.listaPeriodos.length === 1) {
                    this.periodoSeleccionado = this.periodosFormato.listaPeriodos[0];
                    this.validarActivarBotonPagoCuotas();
                } else this.periodoSeleccionado = null;
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodos."); 
            }
        );
    }

    /**
    * @desc Funcion para obtener la periodicidad actual y seleccionar automaticamente el item
    */
    private obtenerPeriodoActual(anio:number) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.obtenerTipoPeriodicidadActualContribuyente(anio);
        observableServicio.subscribe(
            res => {
                this.logger.info("Obteniendo periodicidades ", res);
                this.periodicidadActual = <DPeriodicidadFormato>res;
                this.obtenerPeriodos(anio, this.periodicidadSelecionada);
                precarga.close();
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la periodicidad actual."); 
                window.location.href = location.origin + '/WebDiligenciamiento/DefDiligenciamientoFormularios.faces';
            }
        );
    }    

    /**
    * @desc Funcion para obtener los documentos pendientes y presentados
    * @param {boolean} definitivos
    */
    public obtenerDocs(definitivos?: boolean) {        
        this.obtenerDocsPendientes();
        this.obtenerDocsPresentados();
        if( definitivos) {
            this.obtenerDocsDefinitivos();
        } else {
            this.estadosCarga.definitivos = true;
        }     
    }

    /**
    * @desc Funcion para obtener los documentos pendientes
    */
    public obtenerDocsPendientes() {
        let observableDiligenciamiento = this.dServicioRESTAPI.consultarFormulariosEstado('pendiente'); 
        observableDiligenciamiento.subscribe(
            res => {            
                this.logger.info("Obteniendo Documentos Pendientes ", res);
                this.arrDocumentosDiligenciamiento = <DListaDocumentos>res;               
                this.arrDocumentosDiligenciamiento.infoFormularios.forEach((item, index) => {
                    if (item.modo === 'fraccion' || item.modo === 'fraccion_correccion'){
                        this.hayFraccion = true;
                    }
                    if (item.modo === 'inicial' || item.modo === 'correccion') {
                        this.hayInicial = true;                        
                    }
                });
                this.estadosCarga.pendientes = true;
            },
            error => {
                this.estadosCarga.pendientes = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los documentos presentados
    */
    public obtenerDocsPresentados(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('presentado');
        observablePresentados.subscribe(
            res => {
                this.logger.info("Obteniendo Documentos Presentados ", res);
                this.arrDocumentosPresentados = <DListaDocumentos>res;
                this.estadosCarga.presentados = true;                
            },
            error => {
                this.estadosCarga.presentados = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los documentos definitivos
    */
    public obtenerDocsDefinitivos(){
        let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('definitivo');
        observablePresentados.subscribe(
            res => {
                this.logger.info("Obteniendo Documentos Definitivos ", res);
                this.arrDocumentosDefinitivos = <DListaDocumentos>res;
                this.estadosCarga.definitivos = true;                
            },
            error => {
                this.estadosCarga.definitivos = true;
            }
        );
    }

    /**
    * @desc Funcion para obtener los datos de identidad
    */
    private obtenerIdentidad(){
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();     
        observableServicio.subscribe(
            res => {
                this.datosContexto = <DContextoMuisca>res;
                let datosRespuesta:DContextoMuisca = <DContextoMuisca>res;
                this.consultarTipoContribuyente(datosRespuesta.ANombrePropio ? datosRespuesta.NitUsuario : datosRespuesta.NitOrganizacion);                            
            },                     
            error =>{  
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_CON_IDENTIDAD);                      
            }
        );    
    }

    private validarPeriodicidadListado(){
        if(!this.arrDocumentosDiligenciamiento.infoFormularios.length && !this.arrDocumentosPresentados.infoFormularios.length &&  !this.arrDocumentosDefinitivos.infoFormularios.length) return true;
        for(let documento of this.arrDocumentosDiligenciamiento.infoFormularios){
            if(documento.periodicidad != this.periodicidadSelecionada){
                return false;
            }
        }

        for(let documento of this.arrDocumentosPresentados.infoFormularios){
            if(documento.periodicidad != this.periodicidadSelecionada){
                return false;
            }
        }

        for(let documento of this.arrDocumentosDefinitivos.infoFormularios){
            if(documento.periodicidad != this.periodicidadSelecionada){
                return false;
            }
        } 

        return true;               
    }

    verificarRespuestas(){
        this.consultarRespuesta2020 = (this.anioSeleccionado==2020) && 
                                ((this.periodicidadSelecionada == 'anual') || 
                                (this.periodicidadSelecionada == 'cuatrimestral' && this.periodoSeleccionado.id == 3) ||
                                (this.periodicidadSelecionada == 'bimestral' && (this.periodoSeleccionado.id == 5 || this.periodoSeleccionado.id == 6) ));
        this.consultarRespuesta2021 = (this.anioSeleccionado==2021);

        if(this.consultarRespuesta2020) this.idPregunta = '1';
        if(this.consultarRespuesta2021) this.idPregunta = '2';

        if (!this.consultarRespuesta2020 && !this.consultarRespuesta2021){
            this.crearNuevoBorrador('inicial');
        }else{
            let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
            let respuestasExenciones  = this.dServicioRESTAPI.obtenerRespuestasExenciones(this.anioSeleccionado, this.idPregunta);
            respuestasExenciones.subscribe(
                res => {
                    let respuesta = <DRespuestaExencion>res;       
                    precargaProceso.close();
                    this.enProceso = false;  
                    if (respuesta && respuesta['status'] != 204){
                        // si ha respondido entonces se crea un nuevo borrador
                        this.crearNuevoBorrador('inicial');
                    }else{
                         // no ha respondido se llama el componenete de preguntas
                        this.mostrarDialogoPreguntas();
                    }      
                },
                error => {
                    precargaProceso.close();
                    this.enProceso = false;
                    this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","no se han podido cargar las resuestas registradas anteriormente.",null,null,null,null);
                }
                ); 
        }
    }

    mostrarDialogoPreguntas(){
        let dialogPregunta = this.dialog.open(DialogoRespExencionesComponent, {
            data: { idPregunta: this.idPregunta },
          });
    
        dialogPregunta.afterClosed().subscribe(result => {
            if (result==null){
                this.dNotificacionServicio.mostrarDialogoInformacion("Por favor, seleccione una opcion valida");
            }else{
                this.guardarRespuesta(result);
            }
        },error=>{
            this.dNotificacionServicio.mostrarDialogoError("ha ocurrido un error durante la carga del archivo");
          }
        );
    }

    guardarRespuesta(result:any){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let respuestaexencion = new DRespuestaExencion;
        respuestaexencion.anioGravable = this.anioSeleccionado;
        respuestaexencion.respuesta = result;
        let resultadoPersistencia = this.dServicioRESTAPI.guardarRespuestasExenciones(respuestaexencion, this.idPregunta);
        resultadoPersistencia.subscribe(
            res => {
                // cuando el usuario respondio y las respuestas fueron guardadas entonces se crea un nuevo borrador
                let respuesta = <DRespuestaExencion>res;       
                precargaProceso.close();
                this.enProceso = false;  
                this.crearNuevoBorrador('inicial');
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","no se han guardado las resuestas.",null,null,null,null);
            }
        );  
    }

    /**
    * @desc Funcion para crear un nuevo borrador
    * @param {String} concepto
    */
    public crearNuevoBorrador(concepto: String) {
        const existenPresentados = this.arrDocumentosPresentados.infoFormularios.
                filter(item => item.anio ===this.anioSeleccionado &&  
                       item.periodicidad === this.periodicidadSelecionada &&
                       item.periodo=== this.periodoSeleccionado.id);
        if(existenPresentados && existenPresentados.length && existenPresentados.length >0)
           this.dNotificacionServicio.mostrarDialogoConfirmacion("<h2>Señor contribuyente: </h2><p>Ya tiene presentada una declaración para el año, periodo y peridicidad seleccionada.</p>");
        else
        {       

                if (this.periodicidadActual && this.periodicidadActual.listaPeriodicidades.length && this.periodicidadActual.listaPeriodicidades[0].nombre) {            
                    if (this.periodicidadSelecionada != this.periodicidadActual.listaPeriodicidades[0].nombre)
                {
                        this.obtenerDocumentosAfectadosPorCambioPeriodicidad(this.periodicidadSelecionada, this.anioSeleccionado, concepto);
                    }else{
                            this.redireccionarNuevoBorrador(concepto);     
                    }  
                                        
                }else{
                    if(this.periodicidadSelecionada == "anual"){
                        let dialog = this.dNotificacionServicio.mostrarDialogoConfirmacion("<h2>Señor contribuyente: </h2><p>Recuerde que solamente los contribuyentes del Régimen Simple de Tributación (RST), están obligados a presentar la Declaración Anual Consolidada del impuesto sobre las ventas -IVA. Si usted NO, pertenece al Régimen Simple de Tributación (RST), seleccione la periodicidad Bimestral o Cuatrimestral, de acuerdo a la normatividad vigente.</p>");
                        dialog.afterClosed().subscribe(
                            res=>{
                                if(res)
                                    this.redireccionarNuevoBorrador(concepto);
                            }
                        );
                    }else{
                        this.redireccionarNuevoBorrador(concepto);     
                    }
                }  
        }      
    }

    private redireccionarNuevoBorrador(concepto: String) {
        let queryStringParams;
        if (concepto === 'inicial') {
            queryStringParams = {
                concepto: this.esInicialAnulacion ? 'inicialanulacion' : concepto, 
                anio: this.anioSeleccionado, 
                periodicidad: this.periodicidadSelecionada, 
                periodo: this.periodoSeleccionado.id ? this.periodoSeleccionado.id : "null"
            };
        } else {
            queryStringParams = {
                anio: this.anioSeleccionado || (this.anioSeleccionadoFraccion - 1),
                concepto: concepto,
                periodicidad: "anual", 
                periodo: "1"              
            };
        }

        let params = this.dutilidades.getQueryStringParams(queryStringParams);   
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(this.anioSeleccionado, this.periodicidadSelecionada, this.periodoSeleccionado.id);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;  
                this.logger.info("URL Crear nuevo borrador: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                
                this.redirigirFormulario(version,params);        
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        );  
    }

    private obtenerDocumentosAfectadosPorCambioPeriodicidad(nuevaPeriodicidad: string, anio: number, concepto: String) {        

        if(nuevaPeriodicidad == "anual"){
            let dialog = this.dNotificacionServicio.mostrarDialogoConfirmacion("<h2>Señor contribuyente: </h2><p>Recuerde que solamente los contribuyentes del Régimen Simple de Tributación (RST), están obligados a presentar la Declaración Anual Consolidada del impuesto sobre las ventas -IVA. Si usted NO, pertenece al Régimen Simple de Tributación (RST), seleccione la periodicidad Bimestral o Cuatrimestral, de acuerdo a la normatividad vigente.</p>");
            dialog.afterClosed().subscribe(
                res=>{
                    if(res){
                        this.consultarFormulariosEstadoCambioPeriodicidad(nuevaPeriodicidad,anio,concepto);                       
                    }
                }
            );
        }else{
            this.consultarFormulariosEstadoCambioPeriodicidad(nuevaPeriodicidad,anio,concepto);
        }
    }

    public consultarFormulariosEstadoCambioPeriodicidad(nuevaPeriodicidad: string, anio: number, concepto: String){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let observable = this.dServicioRESTAPI.consultarFormulariosEstadoCambioPeriodicidad(nuevaPeriodicidad, anio);
        observable.subscribe(
            res => {                
                    precargaProceso.close();
                    this.enProceso = false;
                    let listDocs = <DListaDocumentos>res;        

                    const dialogRef = this.dialog.open(DialogConfirmacionComponent, {
                        data: {listaDocumentos: listDocs.infoFormularios}
                    });

                    dialogRef.afterClosed().subscribe(result => {                  
                    if (result) 
                    {
                        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                        this.dServicioRESTAPI.anulacionBorradoresxPeriodicidad(anio, nuevaPeriodicidad)
                        .subscribe(
                            res => {
                                precarga.close();   
                                this.redireccionarNuevoBorrador('inicial'); 
                            },
                            error => {
                                precarga.close();                                                    
                            }
                        );
                        
                        
                    }  
                    else {
                        this.periodicidadSelecionada = this.periodicidadActual.listaPeriodicidades[0].nombre;
                        this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
                    }             
                    /* let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                        this.dServicioRESTAPI.marcarAnulacionDocumentos(anio, nuevaPeriodicidad, listDocs)
                            .subscribe(
                                res => {
                                    precarga.close();
                                    this.esInicialAnulacion = listDocs.infoFormularios.length ? true : false;
                                    this.redireccionarNuevoBorrador('inicial');
                                },
                                error => {
                                    precarga.close();                                                    
                                }
                            );
                        } else {
                            this.periodicidadSelecionada = this.periodicidadActual.listaPeriodicidades[0].nombre;
                            this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
                        }*/
                 }
                );
            },
            error => {
                this.periodicidadSelecionada = this.periodicidadActual.listaPeriodicidades[0].nombre;
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        );        
    }


    /**
    * @desc Funcion para consultar el tipo de contribuyente
    * @param {string} nit del contribuyente
    */
    public consultarTipoContribuyente(nit: string) {
        let observableServicio = this.dRutServicios.consultarTipoContribuyente(nit);
        observableServicio.subscribe(
            res => {
                this.tipoContribuyente = <DTipoContribuyente>res;
                this.constribuyenteId = this.tipoContribuyente.id;           
            },
            error => {
                this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_OBTENIENDO_CONTRIBUYENTE);                
            }
        );
    } 

    /**
    * @desc Funcion para imprimir el formulario
    */
    public imprimirFormulario(idFormulario:string) {
        this.operacionesGenerales.imprimirFormulario(idFormulario);      
    }

    /**
    * @desc Funcion para pagar el formulario
    * @param {String} idFormulario
    * @param {String} anioGravable
    * @param {String} periodo
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public pagarFormulario(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario:DInfoResumenFormulario, periodicidad:string) {
        if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {
            let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario);
            observableServicio.subscribe(
                res => {
                    let liquidacion = <DLiquidacionRecibo>res;
                    if (liquidacion) this.dReciboPagoServicio.mostrarDialogoReciboPago(this.datosContexto,this.firmaRequerida,liquidacion);
                },
                error => {
                     console.log('Servicio generar liquidacion del recigo de pago ejecutado con error');
                }
            );    
        }else{        
            let modelo = new DDocumento();
            modelo.doc.cab.cs_id_4 = idFormulario;
            modelo.doc.cab.cs_id_1 = anioGravable;
            modelo.doc.cab.cs_id_3 = periodo ? periodo : "1";

            let idPeriodicidad: string;        
            if(periodicidad == "bimestral") idPeriodicidad = "19110705"; //bimestral
            if(periodicidad == "cuatrimestral") idPeriodicidad = "19110712"; //cuatrimestral
            if(periodicidad == "anual") idPeriodicidad = "19110708";  

            let contribuyente = this.tipoContribuyente.granContribuyente ? '3' : this.constribuyenteId;
            let atributos = objetoFormulario.atributos.docAtributos;
            let tipoDoc = atributos.esDefinitivo ? '2' : atributos.esPresentado ? '5' : null;
            this.operacionesGenerales.pagarFormulario(modelo, contribuyente, this.configuracionFormulario.NUMERO_FORMULARIO, tipoDoc, idPeriodicidad);
        }
    }   

    /**
    * @desc Funcion para editar el formulario
    * @param {Object} objetoFormulario
    */
    public editarFormulario(objetoFormulario:DInfoResumenFormulario){
        let esCorreccion:boolean = objetoFormulario.infoCorreccion.esCorreccion;
        let queryStringParams = null;
        if(esCorreccion) {
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: objetoFormulario.periodo ? objetoFormulario.periodo : "null",
                documento: objetoFormulario.infoCorreccion.ideDocumentoCorrige
            };            
        } else {           
            queryStringParams = {
                concepto: objetoFormulario.modo,
                anio: objetoFormulario.anio, 
                periodicidad: objetoFormulario.periodicidad, 
                periodo: objetoFormulario.periodo ? objetoFormulario.periodo : "null",
                idedocumento: objetoFormulario.identificador.id
            };
        }

        let params = this.dutilidades.getQueryStringParams(queryStringParams);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();      
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;  
                precargaProceso.close();
                this.enProceso = false;
                this.logger.info("URL Editar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                  
                this.redirigirFormulario(version,params);        
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;            
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        ); 
    }

    /**
    * @desc Funcion para consultar los formularios por aÃ±o gravable
    * @param {Number} anio
    */
    public consultarFormulariosPorAnio(anio:number){
        this.enProceso = true;
        this.anioSeleccionadoPresentados = anio;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let observableServicio = this.dServicioRESTAPI.consultarFormulariosEstado('presentado', anio); 
        observableServicio.subscribe(
            res => {
                this.arrDocumentosPresentados = <DListaDocumentos>res;
                precargaProceso.close();
                this.enProceso = false;
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
            }
        );   
    }

    /**
    * @desc Funcion para corregir un formulario presentado
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public corregirFormulario(objetoFormulario:DInfoResumenFormulario){  
        let esCorreccion = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        esCorreccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": esCorreccion;
        let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;

        let queryStringParams = {
            concepto: esCorreccion,
            anio: objetoFormulario.anio, 
            periodicidad: objetoFormulario.periodicidad, 
            periodo: periodo ? periodo : "null",
            documento: objetoFormulario.identificador.id
        };
        let params = this.dutilidades.getQueryStringParams(queryStringParams);   

        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;    
                this.logger.info("URL Corregir formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);        
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        ); 
    }

    /**
    * @desc Funcion para copiar los formularios cuando son definitivos
    * @param {DInfoResumenFormulario} objetoFormulario
    */
    public copiarFormulario(objetoFormulario: DInfoResumenFormulario) {
        let ideDocumento = String(objetoFormulario.identificador.id);
        let modo = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
        modo = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": modo;
        let anio = Number(objetoFormulario.anio);
        let periodicidad = objetoFormulario.periodicidad;
        let periodo = objetoFormulario.periodicidad === 'anual' || !objetoFormulario.periodo ? 1 : objetoFormulario.periodo;
        let queryStringParams = {
            idedocumento: ideDocumento,
            concepto: modo, 
            anio: anio, 
            periodicidad: periodicidad, 
            periodo: periodo,
            clonar: true
        }; 
        let params = this.dutilidades.getQueryStringParams(queryStringParams);   
        //Version
        this.enProceso = true;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        let anioVersion = Number(objetoFormulario.anio);
        let periodoVersion = Number(objetoFormulario.periodo);
        let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion);
        observableVersionFormato.subscribe(
            res => {
                let version = <DVersionRutaFormato>res;       
                precargaProceso.close();
                this.enProceso = false;  
                this.logger.info("URL Copiar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
                this.redirigirFormulario(version,params);        
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
            }
        );      
    }   

    /**
    * @desc Funcion para obtener todas las versiones del formulario que esten en Angular
    * @param {Number} ideFormato
    */
    public obtenerVersionesRuta(ideFormato:number){
        let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        observableVersionesFormato.subscribe(
            res => { 
                this.versionesRuta = <Array<DVersionRutaFormato>>res;
                let anio = 0;
                for(let version of this.versionesRuta){
                    if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año
                        this.habilitarFraccionAnio = true;//Si hay fracción se activa el toolbar de fracción                        
                        if (anio < version.anioGravable) anio = version.anioGravable; 
                        this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
                    }
                }
                this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
                this.mostrarNuevoBorradorFraccion = this.habilitarFraccionAnio ? true : false;
                precargaProceso.close();
                this.enProceso = false;  
            },
            error => {
                precargaProceso.close();
                this.enProceso = false;
                this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de las versiones del formato");
            }
        );          
    }

    public validarActivarBotonPagoCuotas(){
        let periodicidad = this.periodicidadFormato.listaPeriodicidades.find(period=> period.nombre == this.periodicidadSelecionada);
        let idePeriodicidad;
        if(periodicidad.id == 1){//pendiente consultar este dominio y cruzar contra valores
            idePeriodicidad = 19110708;
        }else if(periodicidad.id == 4){
            idePeriodicidad = 19110706;
        }else if(periodicidad.id == 3){
            idePeriodicidad = 19110712;
        }else if(periodicidad.id == 6){
            idePeriodicidad = 19110705;
        }else if(periodicidad.id == 12){
            idePeriodicidad = 19110704;
        }
        let version = this.versionesRuta.find(ver=> ver.anioGravable == this.anioSeleccionado && ver.idPeriodicidad == idePeriodicidad && this.periodoSeleccionado.id <= ver.idPeriodo && ver.indModoFraccion == "N");        
        if(version && version.indPagoCuota == "S"){
            this.disableBtnPagoCuotas = false;
        }else{
            this.disableBtnPagoCuotas = true;
        }       
    }

    public redirigirFormulario(version:DVersionRutaFormato, params:string){
        if(version.indAccesoFormulario == "N"){
            this.dNotificacionServicio.mostrarDialogoError("El formulario solicitado no esta disponible para su diligenciamiento.");
        }else{
            window.location.href = location.origin + version.urlFormato + 'v' + version.version + '?' + params;
        } 
    }

    public validarPuedePagarCuota(anioSeleccionado){
        let docPresentadoAnio = this.arrDocumentosPresentados.infoFormularios.find( doc => doc.anio == anioSeleccionado);
        if(docPresentadoAnio){
            this.existenDocsPresentadosAnio = true;
        }
    }
    
}





// WEBPACK FOOTER //
// D:/arquitectura/workspace/Form300/Diligenciamiento_IngresoIva300_1.0.0/Diligenciamiento_IngresoIva300_1.0.0/Angular/Iva300Ingreso/src/app/components/ingreso/ingreso.component.ts